import React, { useEffect, useMemo, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import Footer from "../../Footer";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  hide_loader,
  set_new_address_details,
  show_loader,
} from "../../actions/app";
import { getCurrentLocation } from "../../resources/get_current_location";
import api_requests from "../../resources/api_requests";
import { useTranslation } from "react-i18next";

const SetNewAddress = () => {
  const dispacth = useDispatch();
  const navigate = useNavigate();
  const { new_address_details } = useSelector(
    (state) => state.app,
    shallowEqual,
  );
  const [current_address, set_current_address] = useState();
  const [is_error, set_is_error] = useState(false);
  const [number_error, set_number_error] = useState(false);

  const [formData, setFormData] = useState({
    pickupAddress: "",
    senderName: "",
    senderNumber: "",
    saveAddress: "",
    address_type: "",
  });

  const handle_go_back = () => {
    navigate(-1);
    if (btn_disable) {
      dispacth(set_new_address_details({}));
    }
  };
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getCurrentLocation();
        set_current_address(response);
      } catch (error) {
        set_is_error(true);
      }
    }
    if (_.isEmpty(new_address_details)) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(new_address_details)) {
      set_current_address(new_address_details);
      if (new_address_details?.name) {
        setFormData({
          pickupAddress: new_address_details?.address_line1,
          senderName: new_address_details?.name,
          senderNumber: new_address_details?.mobile,
          saveAddress: new_address_details?.label,
          address_type: new_address_details?.meta_info?.type,
        });
      }
    }
    // getLocation();
  }, [new_address_details]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name == "senderNumber") {
      set_number_error(false);
    }
    if (name == "senderNumber" && value.length > 10) return;
    if (name == "saveAddress" && value.length > 10) return;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const _addrees = !_.isEmpty(new_address_details)
      ? _.cloneDeep(new_address_details)
      : _.cloneDeep(current_address);

    const poc_data = [
      { name: formData.senderName, mobile: formData?.senderNumber },
    ];

    const { label, ...restAddress } = _addrees;

    delete restAddress?.address_name;
    delete restAddress?.name;
    delete restAddress?.mobile;
    delete restAddress?.id;
    const data = {
      ...restAddress,
      ...(!_.isEmpty(label) && { label }),
      address_line1: formData.pickupAddress,
      ...(!_.isEmpty(formData.saveAddress) && { label: formData.saveAddress }),
      // is_saved: !_.isEmpty(formData.saveAddress),
      is_saved: true,
    };
    try {
      dispacth(show_loader());
      const res = await api_requests.create_address(data);
      const new_res = await api_requests.update_address(res?.data?.address_id, {
        poc: poc_data,
      });
      dispacth(set_new_address_details({}));
      dispacth(hide_loader());
      navigate(-2);
    } catch (error) {
      dispacth(hide_loader());
    }
  };

  const btn_disable = useMemo(() => {
    let value = true;
    if (
      formData.pickupAddress != "" &&
      formData.senderName != "" &&
      formData.senderNumber != "" &&
      formData.senderNumber.length == 10 &&
      !_.isEmpty(current_address)
    ) {
      value = false;
    }
    return value;
  }, [formData]);

  const { t } = useTranslation();

  return (
    <div className="relative min-h-screen flex mt-6 flex-col">
      <div
        className="overflow-auto"
        style={{ height: `calc(100vh - 64px - env(safe-area-inset-bottom))` }}
      >
        <div
          className="flex items-center gap-2 pl-6 pb-6"
          onClick={handle_go_back}
        >
          <img src={ImageLinks.chevron_right} className="w-[18px] h-[19px]" />
          <p className="font-custom text-sm font-semibold text-dark_black">
            {t("save_address")}
          </p>
        </div>

        <div className="relative bg-[#7953d2]/20 py-4 px-12 flex justify-between items-center">
          {_.isEmpty(current_address) ? (
            <p className="font-custom text-sm text-dark_black font-medium">
              {is_error ? t("select_your_location") : t("fetching_location")}
            </p>
          ) : (
            <div>
              <p className="font-custom text-sm text-dark_black font-bold line-clamp-2 pr-6">
                {current_address?.address_name}
              </p>
              <p className="font-custom text-dark_gray text-[10px] font-medium line-clamp-2">
                {current_address?.formatted_address}
              </p>
            </div>
          )}
          <img
            src={ImageLinks.edit_purple}
            alt="edit"
            className="self-start absolute top-[8px] right-[14px]"
            onClick={() => navigate(-1)}
          />
        </div>

        <form onSubmit={handleSubmit} className="pl-12 pr-12 pt-6 space-y-4">
          <div className="form-control">
            <label
              htmlFor="pickupAddress"
              className="font-custom block mb-2 text-sm font-semibold text-secondary "
            >
              {t("address")}*
            </label>
            <textarea
              id="pickupAddress"
              name="pickupAddress"
              rows="4"
              value={formData.pickupAddress}
              onChange={handleInputChange}
              className="font-custom  p-2.5 w-full text-sm text-dark_black bg-white rounded-lg border border-accents focus:outline-accents "
              placeholder={t("enter_full_address")}
            ></textarea>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="form-control">
              <label
                htmlFor="senderName"
                className="font-custom label-text font-semibold text-secondary"
              >
                {t("full_name")}*
              </label>
              <input
                type="text"
                id="senderName"
                name="senderName"
                value={formData.senderName}
                onChange={handleInputChange}
                className="font-custom block py-0.5 pe-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-accents appearance-none   focus:outline-none focus:ring-0 focus:border-accents peer"
                placeholder={t("enter_name")}
              />
            </div>
            <div className="form-control">
              <label
                htmlFor="senderNumber"
                className={`font-custom label-text font-semibold text-secondary`}
              >
                {t("mobile_number")}*
              </label>
              <div className="flex gap-1">
                <input
                  type="number"
                  id="senderNumber"
                  name="senderNumber"
                  value={formData.senderNumber}
                  onChange={handleInputChange}
                  className="font-custom block py-0.5 pe-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-accents appearance-none  dark:border-accents-600 dark:focus:border-accents focus:outline-none focus:ring-0 focus:border-accents peer"
                  placeholder={t("enter_number")}
                  onBlur={() => {
                    if (formData.senderNumber.length < 10) {
                      set_number_error(true);
                    }
                  }}
                />
                {/* <img
                  src={ImageLinks.phone_contact}
                  alt="Phone icon"
                  onClick={open_contacts}
                /> */}
              </div>
            </div>
          </div>
          {number_error && (
            <p
              className="font-custom font-medium	text-[10px] text-error"
              style={{ marginTop: 2 }}
            >
              {t("invalid_contact_number")}
            </p>
          )}
          <div className="form-control pt-2">
            <label
              htmlFor="saveAddress"
              className="font-custom block mb-2 text-sm font-semibold text-secondary "
            >
              {t("add_label")}
            </label>
            <input
              type="text"
              id="saveAddress"
              name="saveAddress"
              value={formData.saveAddress}
              onChange={handleInputChange}
              className="font-custom bg-gray-50 border border-accents text-sm rounded-lg focus:ring-accents focus:border-accents block w-full p-2.5 focus:outline-accents "
              placeholder={t("address_placeholder")}
            />
          </div>

          {/* <div className="form-control pt-2">
            <label
              htmlFor="saveAddress"
              className="font-custom block mb-2 text-sm font-semibold text-secondary "
            >
              Save Address Type
            </label>
            <div className="flex items-center gap-4">
              <div
                className="flex items-center gap-2"
                onClick={() => {
                  setFormData((prevData) => ({
                    ...prevData,
                    address_type: "pickup",
                  }));
                }}
              >
                <div
                  className={`w-[12px] h-[12px] rounded-md  p-[1px]
                  ${
                    formData.address_type === "pickup"
                      ? "border-primary"
                      : "border-gray"
                  }`}
                  style={{
                    borderWidth: formData.address_type == "pickup" ? 4 : 2,
                  }}
                ></div>
                <p
                  className={`font-custom font-semibold text-xs ${
                    formData.address_type === "pickup"
                      ? "text-black"
                      : "text-gray"
                  }`}
                >
                  Save as Pickup
                </p>
              </div>

              <div
                className="flex items-center gap-2"
                onClick={() => {
                  setFormData((prevData) => ({
                    ...prevData,
                    address_type: "drop",
                  }));
                }}
              >
                <div
                  className={`w-[12px] h-[12px] rounded-md  ${
                    formData.address_type === "drop"
                      ? "border-primary"
                      : "border-gray"
                  }`}
                  style={{
                    borderWidth: formData.address_type == "drop" ? 4 : 2,
                  }}
                ></div>
                <p
                  className={`font-custom font-semibold text-xs ${
                    formData.address_type === "drop"
                      ? "text-black"
                      : "text-gray"
                  }`}
                >
                  Save as Delivery
                </p>
              </div>
            </div>
          </div> */}

          <div className="form-control" style={{ marginTop: "40px" }}>
            <button
              type="submit"
              className="font-custom btn btn-block bg-primary text-white cursor-not-allowed rounded-[30px]"
              disabled={btn_disable}
            >
              {t("save_address")}
            </button>
          </div>
        </form>
      </div>
      <Footer bottom={0} />
    </div>
  );
};

export default SetNewAddress;
